import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-alumni-dpharm',
  templateUrl: './alumni-dpharm.component.html',
  styleUrls: ['./alumni-dpharm.component.css']
})
export class AlumniDpharmComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

  banner: any = {
    pagetitle: "Alumni D-Pharm",
    bg_image: "assets/images/banner/bnr3.jpg",
    title: "Alumni D-Pharm",
  }
}
